/**
 * api.js - API 엔드포인트 설정
 *
 * AICC 백엔드 서버와의 통신을 위한 기본 URL 및 엔드포인트 상수
 * 개발 환경에서는 CRA 프록시, 운영 환경에서는 환경변수로 설정
 *
 * @see ChatPage, OrchestratorChatPage
 */

// API Configuration
// In development, CRA proxy (package.json "proxy") forwards API calls to the backend.
// In production, set REACT_APP_API_BASE_URL to the backend origin, or use same-origin/reverse-proxy.
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';

export const API_ENDPOINTS = {
  CHAT: '/api/chat',
  CHAT_STREAM: '/api/chat/stream',
};
